import { FilterMatchMode } from 'primereact/api';
import { Tag } from 'primereact/tag';

export class MatrizRiesgoCandidata {
    constructor() {
        this.model = {
            codigo: {
                header: 'Código',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '150px' },
                body: (rowData) => <span className="font-bold text-primary">{rowData.codigo}</span>
            },
            nombre: {
                header: 'Nombre Matriz',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '250px' },
            },
            fechas: {
                header: 'Fechas de Análisis',
                table: true,
                sort: false,
                filter: false,
                style: { minWidth: '220px' },
                body: (rowData) => (
                    <div className="flex align-items-center gap-2 text-700 text-sm">
                        <i className="pi pi-calendar"></i>
                        <span>{rowData.fecha_inicio} al {rowData.fecha_fin}</span>
                    </div>
                )
            },
            estado: {
                header: 'Estado',
                table: true,
                sort: true,
                filter: false,
                style: { minWidth: '120px', textAlign: 'center' },
                body: (rowData) => (
                    <div className="flex justify-content-left">
                        <Tag value={rowData.estado} severity="success" />
                    </div>
                )
            },
            acciones: {
                header: 'Acción',
                table: true,
                sort: false,
                filter: false,
                style: { width: '180px' },
                alignHeader: 'center',
                bodyTemplate: 'accionesBody'
            }
        };
    }
}